<template>

<div class="toggle" :class="{'is-flag': flag, 'is-stacked': input.layout.stacked, 'is-stacked-high': input.layout.stacked === 2, 'is-many': input.options.length > 2}">

	<button class="toggle-button" v-for="option in input.options" :key="option.id" v-on:click="onOptionClick(option.value)" :class="{'is-active': isActive(option.value), 'is-disabled': isDisabled(option.value)}"><span>{{ option.text }}</span></button>

</div>

</template>

<script>

export default {

	props: ['input', 'flag'],

	methods: {

		onOptionClick: function(value) {

			this.$store.dispatch('set', {
				input: this.input.id,
				variable: this.input.variable, 
				value: value
			})

		},

		isActive: function(value) {

			if (this.input.multiple.enabled) {

				return this.$_.contains(this.values[this.input.variable], value)

			} else {

				return value === this.values[this.input.variable]

			}

		},

		isDisabled: function(value) {

			if (this.input.multiple.enabled) {

				return this.$_.contains(this.input.disabled || [], value)

			} else {

				return false

			}

		}

	}

}

</script>

<style scoped>

.toggle {
	display: flex;
	flex-direction: row;
	justify-content: flex-end;
	flex-wrap: nowrap;
}

.toggle.is-stacked-high {
	flex-direction: column;
	justify-content: flex-start;
}

.is-mobile .toggle {
	justify-content: flex-start;
}

.is-mobile .toggle.is-many {
	flex-direction: column;
}

.toggle-button {
	min-width: 150px;
	padding: 0px 10px;
	height: 48px;
	border-radius: 24px;
	border: 2px solid var(--primary-color);
	font-size: 18px;
	font-weight: 700;
	color: #343434;
	margin-left: 10px;
	transition: all 300ms ease-in-out;
}

.is-aiding .toggle-button {
	border-color: var(--aid-color);
}

.supplementary-body .toggle-button {
	font-size: 16px;
}

.toggle.is-stacked .toggle-button {
	flex-grow: 1;
}

.toggle.is-stacked-high .toggle-button {
	flex-grow: 0;
	margin-left: 0px;
	margin-bottom: 10px;
	padding: 0px 32px;
	text-align: left;
}

.is-mobile .toggle-button {
	min-width: 100px;
	font-size: 14px;
	height: 32px;
	line-height: 14px;
	border-radius: 16px;
	margin-left: 0px;
	margin-right: 10px;
	width: calc(50% - 5px);
}

.is-mobile .toggle.is-many .toggle-button {
	margin-right: 0px;
	width: 100%;
	margin-bottom: 10px;
}

.toggle-button:first-child {
	margin-left: 0px;
}

.is-mobile .toggle-button:last-child {
	margin-right: 0px;
}

.toggle-button.is-active {
	background-color: #343434;
	border-color: #343434;
	color: #fff;
}

.toggle-button.is-disabled {
	background-color: #fff;
	border-color: #eee;
	color: #eee;
	pointer-events: none;
}

.toggle.is-flag .toggle-button {
	border-color: #ee7173;
}

.toggle-button:not(.is-active):hover {
	background-color: var(--primary-color);
	color: #fff;
}

.is-aiding .toggle-button:not(.is-active):hover {
	background-color: var(--aid-color);
}

</style>